import routerMixin, {IQueryOptions} from "../routerMixin";
import filterElementBaseMixin from "./filterElementBaseMixin";
import ClearListViewFiltersEventBus from "../../../formability/modelViews/buses/clearListViewFiltersEventBus";

export default {
  mixins: [
    filterElementBaseMixin,
    routerMixin,
  ],
  created() {
    this.registerClearFiltersListener();
    this.clearQueryIfInvalid();
    this.setDefaultFilter()
  },
  computed: {
    queryValue(): string {
      return this.$router.currentRoute.query[this.filterElement.client_id] || ''
    },
    isFilterInQuery(): boolean {
      return this.$router.currentRoute.query.hasOwnProperty(this.filterElement.client_id)
    },
    // used to wipe default filters
    isInDashBoardDrillDown(): boolean{
      return !!this.$router.currentRoute.query["from_dashboard_id"]
    }
  },
  methods: {
    registerClearFiltersListener(): void {
      if (!this.reset && import.meta.env.MODE === 'development') {
        throw new Error('Must define reset() method in Vue component');
      }

      ClearListViewFiltersEventBus.onEvent(this.reset);
    },
    clearQueryIfInvalid(): void {
      // implement in component if needed
      // should call this.clearFilter({mode: 'replace'}) if published filter configuration has become invalid
      // e.g. linked property has been un-indexed
    },
    setDefaultFilter(): void {
      if (import.meta.env.MODE === 'development') {
        throw new Error('Must define setDefaultFilter method in Vue component')
      }
    },
    addFilterToQuery(value: string): void {
      this.appendQuery({
        [this.filterElement.client_id]: value,
      }, {
        mode: 'replace',
      })
    },
    clearFilter(opts: IQueryOptions = {}): void {
      this.appendQuery({}, {...opts, clear: [this.filterElement.client_id]});
    },
  },
}